import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';

function VisaPrepUniEnrolmentStep1(props: IVisaPrepForm) {
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_RECEIVED_CAS}
        label={'Have you received your CAS yet?'}
        value={boolToYesNo(props.hasReceivedCas)}
      />
      {props.hasReceivedCas ? (
        <SummaryRow
          className={'visa-summary'}
          key={`${VQ.STUDIES_CONFIRMATION_NUMBER}`}
          value={props.studiesConfirmationNumber}
          label={'What is your Confirmation of Acceptance for Studies Number?'}
        />
      ) : null}
      <SummaryRow
        className={'visa-summary'}
        key={VQ.COURSE_END_DATE}
        label={'Course end date'}
        value={props.courseEndDate}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.ALREADY_STARTED_STUDYING}
        label={'Have you already started studying this course?'}
        value={boolToYesNo(props.alreadyStartedStudying)}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.ASSESSED_BY_SPONSOR}
        label={'Assessed by sponsor'}
        fullLabel={
          'Have you been assessed by the sponsor by other means, for example references or a portfolio of artwork?'
        }
        value={boolToYesNo(props.assessedBySponsor)}
      />
    </>
  );
}

export default VisaPrepUniEnrolmentStep1;
